import type { DatasetsMutatorCreateDatasetsProps } from "./datasets-mutator-create-datasets.type";

import { useDatasetsInterventionCreate } from "@/entities/datasets";

import { useDatasetsMutatorHandleMutate } from "../datasets-mutator.hook";

export const useDatasetsMutatorCreateDatasets = ({
  interventionId,
  sectionLayoutIndex,
  sectionAssetId,
  mutatorItems,
  onObservationCreate,
  invalidateKeys,
}: DatasetsMutatorCreateDatasetsProps) => {
  const { mutate, status } = useDatasetsInterventionCreate(interventionId, {
    invalidateKeys,
    onSuccess: (observation) => onObservationCreate?.(observation.id),
  });

  // This will create the new observation and the related datasets. We should
  // use it only if section do not have related observation id yet.
  const createDatasetsUsingInterventionId = () => {
    const datasets = mutatorItems.map((item) => item.variables);

    mutate({
      layout_index: sectionLayoutIndex,
      asset_id: sectionAssetId,
      datasets,
    });
  };

  useDatasetsMutatorHandleMutate({
    mutatorItems: mutatorItems,
    mutationStatus: status,
    onMutateReady: () => createDatasetsUsingInterventionId(),
  });

  return null;
};
